export default {
  props: {
    color: {
      type: String,
      default: 'var(--primary)',
    },
  },
  methods: {
    disabledMarkerIcon(count = 0) {
      return L.divIcon({ class: 'tmaps-marker-icon-disabled', html: this.getDisabledMarkerHtml(count), iconAnchor: [22.5, 60] });
    },
    markerIcon(count = 0) {
      return L.divIcon({ class: 'tmaps-marker-icon', html: this.getMarkerHtml(count), iconAnchor: [22.5, 60] });
    },
    clusterIconCreateFunction(cluster) {
      const childCount = cluster.getAllChildMarkers().reduce((acc, marker) => {
        return acc + marker.options.count
      }, 0);
      return new L.DivIcon({ html: this.getCircleHtml(childCount), className: 'marker-cluster', iconSize: new L.Point(40, 40) });
    },
    sheetClusterIconCreateFunction(cluster) {
      const containsHoveredSheet = cluster.getAllChildMarkers().some(marker => {
        return this.hoveredSheet && marker._latlng.lat === this.hoveredSheet.lat && marker._latlng.lng === this.hoveredSheet.lng;
      });
      const childCount = cluster.getAllChildMarkers().reduce((acc, marker) => {
        return acc + marker.options.count
      }, 0);
      return new L.DivIcon({
        html: containsHoveredSheet ? this.getCircleHtml(childCount) : this.getDisabledCircleHtml(childCount),
        className: 'marker-cluster',
        iconSize: new L.Point(40, 40),
      });
    },
    getCircleHtml(count) {
      return `
        <svg width="56" height="56">
          <circle fill="white" stroke="${this.color}" stroke-width="7.5px" cx="24" cy="24" r="18"/>
          <text x="24" y="30" text-anchor="middle" stroke="${this.color}" font-size="1.3em" stroke-width="1.5px">${count}</text>
        </svg>
      `;
    },
    getDisabledCircleHtml(count) {
      return `
        <svg width="56" height="56">
          <circle fill="white" stroke="#AAAAAA" stroke-width="7.5px" cx="24" cy="24" r="18"/>
          <text x="24" y="30" text-anchor="middle" stroke="#AAAAAA" font-size="1.3em" stroke-width="1.5px">${count}</text>
        </svg>
      `;
    },
    getMarkerHtml(count) {
      return `
        <svg class="rich-marker" width="45" height="60" viewBox="50.302 134.829 30 40" overflow="visible" enable-background="new 50.302 134.829 30 40" xml:space="preserve">
          <path d="M65.302,135.829c7.731,0,14,6.204,14,13.857s-5.819,16.045-14,24.143c-8.854-8.764-14-16.49-14-24.143 S57.571,135.829,65.302,135.829z" fill="${this.color}"/>
          <circle fill="white" stroke-width="6px" cx="65.302" cy="149.829" r="9"/>
          ${count > 0 ? `<text x="66" y="154" text-anchor="middle" stroke="${this.color}" font-size="1em" stroke-width="1px">${count}</text>` : ''}
        </svg>
      `;
    },
    getDisabledMarkerHtml(count) {
      return `
        <svg class="rich-marker" width="45" height="60" viewBox="50.302 134.829 30 40" overflow="visible" enable-background="new 50.302 134.829 30 40" xml:space="preserve">
          <path d="M65.302,135.829c7.731,0,14,6.204,14,13.857s-5.819,16.045-14,24.143c-8.854-8.764-14-16.49-14-24.143 S57.571,135.829,65.302,135.829z" fill="#AAAAAA"/>
          <circle fill="white" stroke-width="6px" cx="65.302" cy="149.829" r="9"/>
          ${count > 0 ? `<text x="66" y="154" text-anchor="middle" stroke="#AAAAAA" font-size="1em" stroke-width="1px">${count}</text>` : ''}
        </svg>
      `;
    },
  },
};
